import { render, staticRenderFns } from "./clue3.vue?vue&type=template&id=1186bf17&scoped=true&"
import script from "./clue3.vue?vue&type=script&lang=js&"
export * from "./clue3.vue?vue&type=script&lang=js&"
import style0 from "./clue3.vue?vue&type=style&index=0&id=1186bf17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1186bf17",
  null
  
)

export default component.exports